<mat-card>Supprimer</mat-card>
<p>Voulez-vous vraiment supprimer le template ?</p>
<div fxLayout="row">
    <button mat-flat-button (click)="closeTemplate()">Non</button>
    <button mat-flat-button (click)="deleteTemplate()" color="primary">Oui</button>
</div>
